import { Injectable, Inject, DOCUMENT } from "@angular/core";
import { Observable } from 'rxjs';
import { ReplaySubject } from 'rxjs';


@Injectable ()
export class LazyLoadingService {
  private loadedjsLibraries: { [url: string]: ReplaySubject<any> } = {};
  private loadedcssLibraries: { [url: string]: ReplaySubject<any> } = {};
  constructor(@Inject(DOCUMENT) private readonly document: any) { }

  

  public loadJs(url: string): Observable<any> {
    if (this.loadedjsLibraries[url]) {
      return this.loadedjsLibraries[url].asObservable();
    }

    this.loadedjsLibraries[url] = new ReplaySubject();

    const script = this.document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.onload = () => {
      this.loadedjsLibraries[url].next('');
      this.loadedjsLibraries[url].complete();
    };

    this.document.body.appendChild(script);
    return this.loadedjsLibraries[url].asObservable();
  }

  public loadCss(url: string): Observable<any> {
    if (this.loadedcssLibraries[url]) {
      return this.loadedcssLibraries[url].asObservable();
    }
    this.loadedcssLibraries[url] = new ReplaySubject();
    const css = document.createElement("link");
    css.href = url;
    css.rel = 'stylesheet';
    css.onload = () => {
      this.loadedcssLibraries[url].next('');
      this.loadedcssLibraries[url].complete();
    }
    this.document.head.appendChild(css);
    return this.loadedcssLibraries[url].asObservable();
  }

 
}
